import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/omar/OMAR-GLAD.svg'
import _imports_1 from '@/assets/omar/OMAR_SQUARE.svg'
import _imports_2 from '@/assets/icons/svg/replay.svg'


const _withScopeId = n => (_pushScopeId("data-v-2f1a5eb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-col justify-evenly w-full h-full text-center text-white overflow-hidden" }
const _hoisted_2 = { class: "absolute p-2 px-4 rounded-3xl bg-white text-black text-2xl inline-block top-6 left-6" }
const _hoisted_3 = { class: "absolute bottom-4 right-4" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_2,
  alt: "close"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.t('title')), 1 /* TEXT */),
    _createElementVNode("img", {
      class: _normalizeClass(["absolute w-64 h-64", [_ctx.chaos ? 'chaos' : 'trans']]),
      src: _imports_0,
      alt: "omar circle",
      style: _normalizeStyle(_ctx.circleStyle)
    }, null, 6 /* CLASS, STYLE */),
    _createElementVNode("img", {
      class: _normalizeClass(["absolute w-64 h-64", [_ctx.chaos ? 'chaos' : 'trans']]),
      src: _imports_1,
      alt: "omar square",
      style: _normalizeStyle(_ctx.squareStyle)
    }, null, 6 /* CLASS, STYLE */),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.allDone && !_ctx.playingNow)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : (!_ctx.playingNow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createCommentVNode("Button :textcolour=\"'text-black'\" :childclass=\"'text-2xl border-none p-5'\" @click=\"playAgain()\">{{ t('replay') }}</Button"),
              _createVNode(_component_Button, {
                class: "pointer-events-auto bg-white mr-4",
                childclass: 'w-12 h-12',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playAgain()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Button, {
                backgroundcolour: 'bg-sl-green-button',
                textcolour: 'text-white',
                childclass: 'text-2xl border-none p-3 h-12',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setup()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('next')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
    ])
  ]))
}